export const tabValues = {
  schedule: 'SCHEDULE',
  today: 'TODAY',
};
